












import { Vue, Component, Prop } from 'vue-property-decorator';
import TagSpecialCoin, {
  TypeTagVariant
} from '@/componentsV2/atoms/TagSpecialCoin/TagSpecialCoin.vue';
import BirthdayTagIcon from '@/components/icons/BirthdayTagIcon.vue';

@Component({
  components: { TagSpecialCoin, BirthdayTagIcon }
})
export default class TagBirthday extends Vue {
  @Prop({ default: 'medium' }) variant!: TypeTagVariant;
  @Prop({ default: false }) withoutIcon!: boolean;

  get tPrefix() {
    return 'offers.form';
  }
}
